// EXPERIMENT: native_share_title_experiment — remove with experiment cleanup
/**
 * Module-level latch, keyed on the experiment name, so the session is treated once across every share
 * button and remount; a full reload resets it. A treat that doesn't register releases it.
 */
export const nativeShareTitleTreats = new Set<string>();
